import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL

export const getClientClaim = createAsyncThunk("client/get-claim", async (token, thunkAPI) => {
  try {
    const res = await axios.get(
        `${BACKEND_URL}/client/claim`, {
            headers: { Authorization: `Bearer ${token}` },
        });
    // console.log("data", res.data.client);
    return res.data.claims;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || "Failed to fetch providers info");
  }
});

export const createClientClaim = createAsyncThunk(
  "client/create-claim",
  async ({ formData, token }, thunkAPI) => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      };

      const data = new FormData();
      // Dynamically append all fields including the file
      for (const key in formData) {
        if (formData[key] !== undefined && formData[key] !== null && formData[key] !== "") {
          data.append(key, formData[key]);
        }
      }

      const res = await axios.post(`${BACKEND_URL}/client/claim`, data, config);

      return res.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data || "Failed to create claim"
      );
    }
  }
);

export const deleteClientClaim = createAsyncThunk(
  "client/delete-claim",
  async ({ id, token }, thunkAPI) => {
    try {
      await axios.delete(`${BACKEND_URL}/client/claim/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return id; // return ID to remove from state
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data || "Failed to delete claim"
      );
    }
  }
);

export const updateClientClaim = createAsyncThunk(
  "client/update-claim",
  async ({ id, formData, token }, thunkAPI) => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      };

      const data = new FormData();
      for (const key in formData) {
        if (formData[key] !== undefined && formData[key] !== null) {
          data.append(key, formData[key]);
        }
      }

      const res = await axios.put(`${BACKEND_URL}/client/claim/${id}`, data, config);

      return res.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data || "Failed to update claim"
      );
    }
  }
);


const clientClaimSlice = createSlice({
    name: "clientClaim",
    initialState: {
        clientsClaim: null,
    },

        extraReducers: (builder) => {
          builder
            .addCase(getClientClaim.pending, (state) => {
                state.loading = true;
            })
            .addCase(getClientClaim.fulfilled, (state, action) => {
                state.clientsClaim = action.payload;
                state.loading = false;
            })
            .addCase(getClientClaim.rejected, (state, action) => {
                state.error = action.payload || "Failed to fetch client claim"; 
                state.loading = false;
            })
            .addCase(createClientClaim.pending, (state) => {
  state.loading = true;
})
.addCase(createClientClaim.fulfilled, (state, action) => {
  state.loading = false;
  state.clientsClaim = [action.payload.data, ...(state.clientsClaim || [])]; // Prepend new claim
})
.addCase(createClientClaim.rejected, (state, action) => {
  state.error = action.payload || "Failed to create claim";
  state.loading = false;
})
.addCase(deleteClientClaim.fulfilled, (state, action) => {
  state.clientsClaim = state.clientsClaim.filter(claim => claim.id !== action.payload);
})
.addCase(deleteClientClaim.rejected, (state, action) => {
  state.error = action.payload || "Failed to delete claim";
})
.addCase(updateClientClaim.fulfilled, (state, action) => {
  const index = state.clientsClaim.findIndex(claim => claim.id === action.payload.id);
  if (index !== -1) {
    state.clientsClaim[index] = action.payload;
  }
})
.addCase(updateClientClaim.rejected, (state, action) => {
  state.error = action.payload || "Failed to update claim";
})

            },
});

export default clientClaimSlice.reducer;